import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startReport200085Status: 'idle',
    startReport200085Error: undefined as any,
    loadUserParamsReport200085Status: 'idle',
    loadUserParamsReport200085Error: undefined as any,

    report200085List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startReport200085 = createAsyncThunk('report200085Slice/startReport200085', async ({ report200085 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartReport200085/`,
        prepareData(report200085),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startReport200085Status } = getState().report200085Slice
        return startReport200085Status !== 'pending'
    }
})

export const loadUserParamsReport200085 = createAsyncThunk('report200085Slice/loadUserParamsReport200085', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsReport200085/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsReport200085Status } = getState().report200085Slice
        return loadUserParamsReport200085Status !== 'pending'
    }
})

const Report200085Slice = createSlice({
    name: 'report200085Slice',
    initialState,
    reducers: {
        resetstartReport200085: (state) => {
            state.job = undefined
            state.startReport200085Error = undefined
        },
        resetstartReport200085Error: (state) => {
            state.startReport200085Error = undefined
        },
        resetloadUserParamsReport200085: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsReport200085Error = undefined
        },
        resetloadUserParamsReport200085Error: (state) => {
            state.loadUserParamsReport200085Error = undefined
        },
        removeFromReport200085ListById: (state, action) => {
            state.report200085List = state.report200085List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromReport200085ListByIds: (state, action) => {
            state.report200085List = state.report200085List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.report200085List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startReport200085Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.report200085List = []
            state.startReport200085Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startReport200085.pending, (state) => {
            state.startReport200085Status = 'pending'
            state.startReport200085Error = undefined
        })
        builder.addCase(startReport200085.fulfilled, (state, action) => {
            state.startReport200085Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startReport200085.rejected, (state, action) => {
            state.startReport200085Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startReport200085Error = action.error.message
            } else {
                state.startReport200085Error = action.payload
            }
        })

        builder.addCase(loadUserParamsReport200085.pending, (state) => {
            state.loadUserParamsReport200085Status = 'pending'
            state.loadUserParamsReport200085Error = undefined
        })
        builder.addCase(loadUserParamsReport200085.fulfilled, (state, action) => {
            state.loadUserParamsReport200085Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsReport200085.rejected, (state, action) => {
            state.loadUserParamsReport200085Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsReport200085Error = action.error.message
            } else {
                state.loadUserParamsReport200085Error = action.payload
            }
        })

    }
})

export const {
    resetstartReport200085,
    resetstartReport200085Error,
    resetloadUserParamsReport200085,
    resetloadUserParamsReport200085Error,
    removeFromReport200085ListById,
    removeFromReport200085ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Report200085Slice.actions
export default Report200085Slice.reducer
